import { ArrangeProps, arrange } from './arrange';

/**
 * Columns
 *
 * CSS Columns have its limititations. To overcome these limitiations every direct
 * child of columns needs to have columnsItem styling. The problems this solves are:
 *
 * 1. Prevent breaking a single item over multiple columns.
 * 2. CSS columns has no concept of row gaps, only column gaps.
 *    The ColumnsItem can take care of the row gaps.
 *    This is handled via a CSS Custom Property on the Columns component.
 * 3. To make components fit together in any layout there should be no
 *    space arround elements. Columns and Columns Item handle this together.
 */
export const columns = (props: Omit<ArrangeProps<'columns'>, 'layout'>) => {
	return arrange({ ...props, layout: 'columns' });
};
